/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WhiteListCarDto } from './whiteListCarDto';


export interface WhiteListCarDtoPagedResultDto { 
    items?: Array<WhiteListCarDto> | null;
    totalCount?: number;
}

